// Pure resolution of the demo launch parameters (initial scene + language) from
// the request URL. Extracted from demo.ts so the URL -> scene mapping can be
// unit-tested without the bootstrap's DOM side effects (see
// Tests/PublicTests/README.md). `demo.ts` passes `window.location` here.

export interface DemoRequest {
  pathname: string;
  search: string;
}

export interface DemoLaunchParams {
  language: string;
  scene: string;
}

export const DemoLaunch = {
  // Initial scene = the last real path segment, ignoring any leading/trailing
  // slashes so a trailing "/" never changes the result. The bare demo base
  // ("/demo", "/demo/") and the site root fall back to the default "concept"
  // scene (the server mounts the demo at "demo/:demo", so "demo" is the base,
  // not a scene). For local development with simple static servers, also
  // supports a `scene` query parameter (e.g., `?scene=quickstart-voyage`).
  scene(pathname: string, search: string): string {
    // Check query parameter first (for local static server development)
    const sceneParam = new URLSearchParams(search).get("scene");
    if (sceneParam) {
      return sceneParam;
    }
    // Fall back to pathname-based routing
    const segments = pathname.split("/").filter(Boolean);
    const last = segments[segments.length - 1];
    return !last || last === "demo" ? "concept" : last;
  },

  // Language from the `lang` query parameter, defaulting to English.
  language(search: string): string {
    return new URLSearchParams(search).get("lang") || "en";
  },

  resolve(request: DemoRequest): DemoLaunchParams {
    return {
      language: DemoLaunch.language(request.search),
      scene: DemoLaunch.scene(request.pathname, request.search),
    };
  },
};
